var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyerAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "buyer_access",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,9.4c-0.1-0.2-0.3-0.4-0.4-0.5l-8.5-6.5c-0.3-0.3-0.6-0.4-1-0.4c-0.3,0-0.6,0.1-0.9,0.3L2.6,8.8 C2.4,9,2.3,9.2,2.2,9.4C2.1,9.6,2,9.8,2,10v10.2c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.4,0.6s0.4,0.3,0.6,0.4 C3.3,22,3.5,22,3.8,22H7h10.1h3.3c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.1-0.6 V10C22,9.8,21.9,9.6,21.8,9.4z M8.8,20.5c0.2-0.4,0.4-0.7,0.7-1s0.7-0.6,1.1-0.8c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,0.9,0.1,1.3,0.3 c0.4,0.2,0.8,0.4,1.1,0.8c0.3,0.3,0.5,0.7,0.7,1H8.8z M20.4,20.5h-0.1h-3.6c0-0.2-0.1-0.3-0.2-0.5c-0.3-0.6-0.6-1.2-1.1-1.6 c-0.5-0.5-1-0.8-1.6-1.1c-0.6-0.3-1.3-0.4-1.9-0.4c-0.7,0-1.3,0.1-1.9,0.4s-1.2,0.6-1.6,1.1c-0.5,0.5-0.8,1-1.1,1.6 c-0.1,0.2-0.1,0.3-0.2,0.5H3.8H3.7l-0.1-0.1l-0.1-0.1v-0.1V10l8.4-6.5l8.5,6.5V20.5L20.4,20.5L20.4,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,10.6c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8C14.8,11.9,13.5,10.6,12,10.6z  M12,14.7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3C13.3,14.1,12.7,14.7,12,14.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerAccess);
export default __webpack_public_path__ + "static/media/buyer_access.7dec7485d56427a76c396c66fe782190.svg";
export { ForwardRef as ReactComponent };